import '../themeDefaults';

export default ({ datepickerReact }) => ({
  alignLeft: {
    left: 0
  },
  alignRight: {
    right: 0,
    ...datepickerReact.chevronPointsUp,
    ...datepickerReact.chevronAlignsRight
  },
  clickOutsideToClose: {
    '&$closeButton': {
      position: 'fixed'
    },
    '&$overlay': {
      position: 'static'
    }
  },
  closeButton: {
    border: 0,
    borderRadius: 0,
    height: '100%',
    left: 0,
    opacity: 0,
    position: 'relative',
    top: 0,
    width: '100%',
    zIndex: 1
  },
  labelText: {},
  onBottom: {
    '&$labelText': {
      top: datepickerReact.inputHeight + datepickerReact.labelHeight
    },
    '&$screenReaderLabel': {
      top: datepickerReact.inputHeight
    },
    '&$usePortal': {
      top: 'auto'
    },
    top: datepickerReact.inputHeight
  },
  onTop: {
    bottom: datepickerReact.inputHeight,
    ...datepickerReact.chevronPointsDown
  },
  overlay: {
    height: '100%',
    left: 0,
    position: 'fixed',
    top: 0,
    width: '100%',
    zIndex: 9999
  },
  popup: {
    position: 'absolute',
    zIndex: 2,
    ...datepickerReact.chevron
  },
  screenReaderLabel: {},
  usePortal: {
    '&$alignLeft': {
      left: 'auto'
    },
    '&$alignRight': {
      right: 'auto'
    },
    '&$onTop': {
      bottom: 'auto'
    },
    '&$overlay': {
      position: 'fixed'
    }
  }
});
